module.exports = __webpack_public_path__ + "static/media/polytope_52_5_52_vertex_explode.6fd24e5a.gif";